import Env from "../base/env";
import Component from "gia/Component";
import { getCoords } from "../utils/utils";
import gsap from "gsap";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    if (this.DOM.view.querySelector("video") != null) {
      this.MEDIA_TYPE = "video";
      this.DOM.media = this.DOM.view.querySelector("video");
    } else {
      this.MEDIA_TYPE = "img";
      this.DOM.media = this.DOM.view.querySelector("img");
    }

    gsap.delayedCall(0.2, () => {
      this.VARS = {
        dimensions: getCoords(this.DOM.media),
      };
      // console.log(getCoords(this.DOM.media));
      gsap.set(this.ref.cache, {
        width: this.VARS.dimensions.width + 50,
        height: this.VARS.dimensions.height + 50,
      });
      if (this.MEDIA_TYPE == "img") {
        gsap.set(this.DOM.view.querySelector("picture"), {
          width: this.VARS.dimensions.width,
          height: this.VARS.dimensions.height,
        });
      }
    });
    if (Env.mobileCSS == false) {
      this.DOM.view.addEventListener("mouseenter", () => {
        gsap.set(this.DOM.view, { zIndex: Env.zIndexHover });
        gsap.fromTo(
          this.ref.cache,
          {
            scaleY: 1,
            transformOrigin: "left bottom",
          },
          {
            scaleY: 0,
            duration: 0.6,
            ease: "quart.inOut",
          }
        );
        Env.zIndexHover++;
        if (this.MEDIA_TYPE == "video") {
          this.DOM.media.play();
        }
      });
      this.DOM.view.addEventListener("mouseleave", () => {
        if (this.MEDIA_TYPE == "video") {
          this.DOM.media.pause();
          this.DOM.media.currentTime = 0;
        }
        // gsap.fromTo(
        //   this.ref.cache,
        //   {
        //     transformOrigin: "left top",
        //   },
        //   {
        //     scaleY: 1,
        //     duration: 0.8,
        //     ease: "quart.inOut",
        //   }
        // );
      });
    }
  }

  unmount() {}
}
